import { Injectable, signal } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class CourseSearchPathService {
	private _defaultPath = '/courses/degrees';
	path = signal<string>(this._defaultPath);
}
